import React, { useEffect } from 'react';
import { FlexAlignType, View } from 'react-native';
import { useSafeAreaInsets, SafeAreaProvider } from 'react-native-safe-area-context';
import { asHexColor } from '../services/colors';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

interface DefaultPageContainerProps {
    children: React.ReactNode | undefined;
    customBackgroundColor?: string;
    customTopInsetColor?: string;
    excludeBottomPadding?: boolean;
    justifyContent?: | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
    alignItems?: FlexAlignType;
}

export default function DefaultPageContainer(props: DefaultPageContainerProps) {
    const { theme } = useStyles();
    const insets = useSafeAreaInsets();

    useEffect(() => {
        if (window.AndroidBridge?.setThemeColor) {
            window.AndroidBridge.setThemeColor(theme, asHexColor(UnistylesRuntime.themeName === 'light' ? '#000028' : '#181A1B'));
        }
    }, [theme]);

    return (
        <>
            <SafeAreaProvider
                initialSafeAreaInsets={insets}
                style={{ flex: 0, backgroundColor: props.customTopInsetColor || UnistylesRuntime.themeName === 'light' || UnistylesRuntime.themeName == 'lightAlt' ? '#000028' : '#181A1B', paddingTop: insets.top }}
            />
            <SafeAreaProvider
                initialSafeAreaInsets={insets}
                style={{
                    flex: 1,
                    backgroundColor: theme.colors.defaultPageContainer.background,
                    paddingBottom: props.excludeBottomPadding ? 0 : insets.bottom,
                }}
            >
                <View style={{
                    flex: 1,
                    backgroundColor: props.customBackgroundColor || theme.colors.defaultPageContainer.background,
                    justifyContent: props.justifyContent,
                    alignItems: props.alignItems
                }}>
                    <meta name='theme-color' content={props.customTopInsetColor || UnistylesRuntime.themeName === 'light' || UnistylesRuntime.themeName == 'lightAlt' ? '#000028' : '#181A1B'} />
                    <meta name='apple-mobile-web-app-status-bar-style' content={props.customTopInsetColor || UnistylesRuntime.themeName === 'light' || UnistylesRuntime.themeName == 'lightAlt' ? '#000028' : '#181A1B'} />
                    <>
                        {props.children}
                    </>
                </View>
            </SafeAreaProvider>
        </>
    );
}

